import React from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import routes from "../../../assets/apiRoutes.json"
import TextBox from 'devextreme-react/text-box';
import axios from "axios";
import notify from 'devextreme/ui/notify';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import {
    Validator,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import TextArea from 'devextreme-react/text-area';
let accessToken = '';
const orchardCodesSelectBox = React.createRef();
const blockCodesSelectBox = React.createRef();
class AddBlockCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orchard :"",
            code: "",
            description: "",
            status: "A",
            comment: ""            
        };
        accessToken = props.oidc.user.access_token;
        this.SaveRecord = this.SaveRecord.bind(this); 
        this.OrchardCodeChanged = this.OrchardCodeChanged.bind(this);        
        this.LoadOrchardCodes = this.LoadOrchardCodes.bind(this);               
        this.Reset = this.Reset.bind(this);
        this.statusArr = [{ id: 1, name: 'Active', value: 'A' }, { id: 2, name: 'Inactive', value: 'I' }];
    }
    componentDidMount() {
        this.LoadOrchardCodes();
    }  
 
    LoadOrchardCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Orchard.GetOrchardCodesLookUp}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let OrchardCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                orchardCodesSelectBox.current.instance().option(
                    "dataSource",
                    OrchardCodesDataStore
                );
                orchardCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            })
            .catch((err) => {
                console.log(err, "Error in loading orchard codes");
            });
    }

    OrchardCodeChanged(e) {
        this.setState({
            orchard: e.value,            
        });       
    }

    Reset() {
        this.setState({
            orchard :"",
            code: "",
            description: "",
            status: "A",
            comment: ""  
        });
    }
    SaveRecord(e) {
        e.preventDefault();
        var rqst = this.state;
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.Blocks.InsertBlockCode }`, rqst,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data == "Block code already exist.") {
                    notify({
                        message: 'Block code already exist!',
                        width: 100,
                    }, 'error', 2000);
                }
                else {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                    this.props.parentCallback();
                    this.Reset();
                }
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
            });
    }
    render() {
        return (
            <div>                
                <form onSubmit={(e) => this.SaveRecord(e)}>   
                <div className="row">
                        <label htmlFor="block-orchard" className="field-label">
                            Orchard
                        </label>
                        <SelectBox
                            ref={orchardCodesSelectBox}
                            searchEnabled={true}
                            placeholder="Select Orchard"
                            onValueChanged={this.OrchardCodeChanged}
                            displayExpr="name"
                            valueExpr="id"
                            name="block-orchard"
                            className="w-100"
                            value={this.state.orchard}
                            acceptCustomValue={true}>
                            <Validator>
                                <RequiredRule message="Orchard Code is required." />
                            </Validator>
                        </SelectBox>
                    </div>             
                    <div className="row">
                        <label htmlFor="block-code" className="field-label">
                            Code
                        </label>
                        <TextBox
                            id="block-code"
                            className="input-field"
                            type="text"
                            placeholder="Enter Block Code"
                            onValueChanged={(data) => this.setState({ code: data.value })}
                            name="block-code"
                            value={this.state.code}>
                            <Validator>
                                <RequiredRule message="Code(Block) is required." />
                                <StringLengthRule message="Code must have at least 3 chracters and maximum 20" min={3} max={20} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="block-description" className="field-label">
                            Description
                        </label>
                        <TextBox
                            id="block-description"
                            className="input-field"
                            type="text"
                            placeholder="Enter Description"
                            onValueChanged={(data) => this.setState({ description: data.value })}
                            name="block-description"
                            value={this.state.description}>
                            <Validator>
                                <StringLengthRule message="Description must have at least 3 chracters and maximum 40" min={3} max={50} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="status-sb" className="field-label">
                            Status
                        </label>
                        <SelectBox
                            displayExpr="name"
                            valueExpr="value"
                            dataSource={this.statusArr}
                            name="status-sb"
                            className="w-100"
                            defaultValue={"A"}
                            value={this.state.status}
                            onValueChanged={(data) => this.setState({ status: data.value })}
                        />
                    </div>                
                    <div className="row">
                        <label htmlFor="block-comment" className="field-label">
                            Comment
                        </label>
                        <TextArea
                            id="block-comment"
                            className="input-field"
                            placeholder="Enter Comment"
                            onValueChanged={(data) => this.setState({ comment: data.value })}
                            name="block-comment"
                            value={this.state.comment}
                            height={90}
                        />
                    </div>          
                                 
                    <div className="row">
                        <div className="col-md-12" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <ValidationSummary id="summary" />
                            <div className="d-flex align-items-center mt-4 addEdit-form-btn">
                            <Button
                                    text="Save Record"
                                    type="default"
                                    useSubmitBehavior={true}
                                    stylingMode="contained">
                                </Button>
                                <Button
                                    onClick={this.Reset}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                            </div>
                        </div>
                    </div>
                </form >
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AddBlockCode);